import { render, staticRenderFns } from "./memberkit.vue?vue&type=template&id=84b9713a&scoped=true&"
import script from "./memberkit.vue?vue&type=script&lang=js&"
export * from "./memberkit.vue?vue&type=script&lang=js&"
import style0 from "./memberkit.vue?vue&type=style&index=0&id=84b9713a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9713a",
  null
  
)

export default component.exports